// directives/foldToggle.js

export default {
  // 指令挂载时
  mounted(el, binding) {// 1. 初始化状态
    // 如果传了参数 v-fold-toggle:folded，则初始为折叠状态
    const isInitiallyFolded = binding.value === 'folded' || binding.arg === 'folded';
    // 存储状态到 DOM 数据集，方便后续读取
    el._foldState = isInitiallyFolded;
    applyHeight(el, isInitiallyFolded);// 2. 设置初始样式
    el.style.transition = 'none';// 确保初始没有过渡动画（防止页面加载时闪烁）
    // 3. 监听点击事件
    // 需求：点击子组件触发。这里监听父级自身的点击，利用事件冒泡
    // 如果你只想让特定子元素触发，可以在 binding.value 中传入选择器
    el._clickHandler = (e) => {
      // 可选：如果 binding.value 是字符串（选择器），则判断点击的是否匹配
        if (typeof binding.value === 'string') {
            if (!e.target.matches(binding.value) && !e.target.closest(binding.value)) {
                return; // 点击的不是目标子元素，忽略
            }
        }
      // 阻止默认行为（可选，防止链接跳转等干扰）
      // e.preventDefault(); 
      toggleFold(el);
    };
    el.addEventListener('click', el._clickHandler);
  },
  // 指令更新时（如果状态通过 prop 外部控制）
  updated(el, binding) {
    const newState = binding.value === 'folded' || binding.arg === 'folded';
    if (newState !== el._foldState) {
      el._foldState = newState;
      applyHeight(el, newState);
    }
  },
  // 指令卸载时清理监听
  unmounted(el) {
    if (el._clickHandler) {
      el.removeEventListener('click', el._clickHandler);
    }
  }
};
/**
 * 执行折叠/展开切换逻辑
 */
function toggleFold(el) {
  const isCurrentlyFolded = el._foldState;
  const targetFolded = !isCurrentlyFolded; // 取反
  
  // 更新状态
  el._foldState = targetFolded;

  // 关键：在改变高度前，先确保 transition 开启
  // 使用 requestAnimationFrame 或 setTimeout 确保浏览器重绘
  el.style.transition = 'height 0.5s ease-in-out';
  
  // 强制重绘 (Reflow)，确保上面的 transition 生效，且当前高度被“锁定”
  el.offsetHeight; 

  applyHeight(el, targetFolded);
}

/**
 * 应用高度
 * @param {HTMLElement} el 
 * @param {Boolean} shouldFold true=折叠到200px, false=展开到真实高度
 */
function applyHeight(el, shouldFold) {
  if (shouldFold) {
    // 折叠：固定高度
    el.style.height = '200px';
  } else {
    // 展开：获取真实内容高度
    // scrollHeight 包含 padding，不包含 margin
    const fullHeight = el.scrollHeight;
    el.style.height = fullHeight + 'px';
  }
}